export const isIOSSafari = () => {
  const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return isSafari && iOS;
  // if (isSafari && iOS) {
  //     alert("You are using Safari on iOS!");
  // } else if(isSafari) {
  //     alert("You are using Safari.");
  // }
};
